// Types
import { ResultQuery } from "interfaces/searchPage/osaSearch";

export const showHideLocations = (
	result: ResultQuery,
	showNumberLocations: number,
	setShowNumberLocations: (numberLocation: number) => void,
	setLabelShowHideLocations: (location: string) => void,
	defaultNumberLocationToShow = 3
) => {
	if (showNumberLocations === result.locations.length) {
		setShowNumberLocations(defaultNumberLocationToShow);
		setLabelShowHideLocations("Mostra");
	} else {
		setShowNumberLocations(result.locations.length);
		setLabelShowHideLocations("Nascondi");
	}
};
